import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../../../text/messages';

class BackgroundCheckTab extends React.Component {
    render() {
        return (
            <div className="row">
                <div className="col-xs-12">
                    <FormattedMessage {...messages.backgroundCheck} />
                </div>
            </div>
        );
    }
}

export default BackgroundCheckTab;



// WEBPACK FOOTER //
// ./src/pages/approval/tabs/backgroundCheck.jsx